import { useCallback } from "react";

import { EmptyState, IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

interface ITopicEmptyState {
    onAutoGenerate?: VoidFunction;
    onManualCreation?: VoidFunction;
}

export const TopicEmptyState = ({ onAutoGenerate, onManualCreation }: ITopicEmptyState) => {
    const CtaButtons = useCallback(
        () => (
            <Flex
                flexDirection="column"
                alignItems="center"
                gap="4px"
            >
                <IconButton
                    data-automation="prompts-empty-state-auto-generate"
                    iconName="sparkles-ai-2"
                    isDisabled={!onAutoGenerate}
                    onClick={onAutoGenerate}
                >
                    {translate("llm.prompts.edit.prompts-table.empty-state.cta.auto")}
                </IconButton>
                <IconButton
                    data-automation="prompts-empty-state-manual-create"
                    type="flat"
                    iconName="add"
                    isDisabled={!onManualCreation}
                    onClick={onManualCreation}
                >
                    {translate("llm.prompts.edit.prompts-table.empty-state.cta.manual")}
                </IconButton>
            </Flex>
        ),
        [onAutoGenerate, onManualCreation],
    );

    return (
        <EmptyState
            title={translate("llm.prompts.edit.prompts-table.empty-state.title")}
            subtitle={translate("llm.prompts.edit.prompts-table.empty-state.subtitle")}
            iconName="no-data-tree"
            CtaButtons={CtaButtons}
        />
    );
};
